'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><rect width={24} height={24} fill="currentColor" rx={3} /><g clipPath="url(#mnd-filled_svg__a)"><path fill="#fff" d="M9.29 24.137v-9.641c0-.405.012-.82.146-1.207a2.85 2.85 0 0 1 2.841-1.91c2.04 0 2.858 1.213 2.858 3.085v9.64h3.878v-9.64c0-1.76.963-3.101 2.882-3.085 1.001 0 1.668.21 2.105.588V7.75a10.5 10.5 0 0 0-2.21-.22 6.36 6.36 0 0 0-4.551 1.896C16.21 8.213 14.58 7.53 12.173 7.53c-3.148 0-6.527 1.76-6.527 5.456v11.15z" /></g><defs><clipPath id="mnd-filled_svg__a"><rect width={24} height={24} fill="#fff" rx={3} /></clipPath></defs></svg>;
const IconMndFilled = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconMndFilled;